import script from "./SimuladorFiscal.vue?vue&type=script&setup=true&lang=js"
export * from "./SimuladorFiscal.vue?vue&type=script&setup=true&lang=js"

import "./SimuladorFiscal.vue?vue&type=style&index=0&id=adf518f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf518f4"]])

export default __exports__